import { render } from "./PremiumPlanCard.vue?vue&type=template&id=c2034b7c"
import script from "./PremiumPlanCard.vue?vue&type=script&lang=js"
export * from "./PremiumPlanCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__